export default function ShownWhen({ children, condition }) {
  return condition ? children : null;
}
